import React from "react";
import "./ContactComponent.css"

const ContactComponent = () => {
  return (
    <>
      <section
        className="troo-da-contact-page-section"
        id="troo-da-contact-page-section"
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="troo-tile">
                <span>Our contact detail</span>
                <h2>Let’s talk to with us</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="troo-contact">
                <div className="row">
                  <div className="col-md-4">
                    <div className="conatct-col">
                      <div className="contact-ss">
                        <div className="contcat-img">
                          <svg
                            width="19"
                            height="18"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_156_3988)">
                              <path
                                d="M19.166 21.6667C19.166 21.8877 19.0782 22.0997 18.9219 22.2559C18.7657 22.4122 18.5537 22.5 18.3327 22.5H6.66602C6.48268 22.5 6.30768 22.6667 6.15768 22.775L3.33268 25V11.6667C3.33268 11.4457 3.42048 11.2337 3.57676 11.0774C3.73304 10.9212 3.945 10.8334 4.16602 10.8334H7.38268V9.16669H4.16602C3.50297 9.16669 2.86709 9.43008 2.39825 9.89892C1.92941 10.3678 1.66602 11.0036 1.66602 11.6667V26.6667C1.66726 26.8215 1.71157 26.9728 1.794 27.1038C1.87642 27.2348 1.9937 27.3403 2.13268 27.4084C2.26658 27.4692 2.41421 27.4936 2.56058 27.479C2.70694 27.4643 2.84683 27.4112 2.96602 27.325L7.25768 24.1667H18.4577C18.7735 24.176 19.0879 24.1204 19.3814 24.0033C19.6749 23.8862 19.9412 23.7101 20.1638 23.4859C20.3865 23.2617 20.5607 22.9941 20.6758 22.6999C20.7908 22.4056 20.8442 22.0908 20.8327 21.775V20.8334H19.166V21.6667Z"
                                fill="#232323"
                              />
                              <path
                                d="M25.8327 3.33331H11.666C11.003 3.33331 10.3671 3.59671 9.89825 4.06555C9.42941 4.53439 9.16602 5.17027 9.16602 5.83331V15.8333C9.16602 16.4964 9.42941 17.1322 9.89825 17.6011C10.3671 18.0699 11.003 18.3333 11.666 18.3333H22.9577L26.941 21.425C27.0594 21.5125 27.1989 21.5671 27.3453 21.5832C27.4917 21.5993 27.6397 21.5764 27.7744 21.5166C27.9162 21.4491 28.036 21.3429 28.12 21.2102C28.2041 21.0775 28.2489 20.9237 28.2494 20.7666V5.83331C28.2497 5.18446 27.9978 4.56089 27.5468 4.09437C27.0959 3.62785 26.4812 3.35494 25.8327 3.33331ZM26.666 19.1166L23.7493 16.8416C23.6039 16.7288 23.4251 16.6672 23.241 16.6666H11.666C11.445 16.6666 11.233 16.5788 11.0768 16.4226C10.9205 16.2663 10.8327 16.0543 10.8327 15.8333V5.83331C10.8327 5.6123 10.9205 5.40034 11.0768 5.24406C11.233 5.08778 11.445 4.99998 11.666 4.99998H25.8327C26.0554 5.0202 26.2631 5.12116 26.4166 5.28386C26.5701 5.44656 26.6588 5.65976 26.666 5.88331V19.1166Z"
                                fill="#232323"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_156_3988">
                                <rect width="30" height="30" fill="#232323" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <div className="contact-deials">
                          <h5>Contact Us</h5>
                          <a href="tel:+44 123 456 7890">+44 123 456 7890</a>
                          <a href="mailto:info@troospa.com">info@troospa.com</a>
                        </div>
                      </div>
                      <div className="contact-ss">
                        <div className="contcat-img">
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15 16.875C14.0729 16.875 13.1666 16.6001 12.3958 16.085C11.6249 15.5699 11.0241 14.8379 10.6693 13.9813C10.3145 13.1248 10.2217 12.1823 10.4026 11.273C10.5834 10.3637 11.0299 9.5285 11.6854 8.87294C12.341 8.21738 13.1762 7.77094 14.0855 7.59007C14.9948 7.4092 15.9373 7.50203 16.7938 7.85682C17.6504 8.2116 18.3824 8.81241 18.8975 9.58327C19.4126 10.3541 19.6875 11.2604 19.6875 12.1875C19.686 13.4302 19.1917 14.6217 18.3129 15.5004C17.4342 16.3792 16.2427 16.8735 15 16.875ZM15 9.375C14.4437 9.375 13.9 9.53995 13.4375 9.84899C12.9749 10.158 12.6145 10.5973 12.4016 11.1112C12.1887 11.6251 12.133 12.1906 12.2415 12.7362C12.3501 13.2818 12.6179 13.7829 13.0113 14.1762C13.4046 14.5696 13.9057 14.8374 14.4513 14.946C14.9969 15.0545 15.5624 14.9988 16.0763 14.7859C16.5902 14.573 17.0295 14.2126 17.3385 13.75C17.6476 13.2875 17.8125 12.7438 17.8125 12.1875C17.8118 11.4418 17.5152 10.7269 16.9879 10.1996C16.4606 9.6723 15.7457 9.37575 15 9.375Z"
                              fill="#232323"
                            />
                            <path
                              d="M15 28.125L7.09126 18.7978C6.98137 18.6578 6.87261 18.5168 6.76501 18.375C5.41406 16.5954 4.68424 14.4218 4.68751 12.1875C4.68751 9.45246 5.774 6.82943 7.70797 4.89546C9.64194 2.96149 12.265 1.875 15 1.875C17.7351 1.875 20.3581 2.96149 22.292 4.89546C24.226 6.82943 25.3125 9.45246 25.3125 12.1875C25.3158 14.4208 24.5863 16.5934 23.2359 18.3722L23.235 18.375C23.235 18.375 22.9538 18.7444 22.9116 18.7941L15 28.125ZM8.26126 17.2453C8.26314 17.2453 8.48064 17.5341 8.53032 17.5959L15 25.2263L21.4781 17.5856C21.5194 17.5341 21.7388 17.2434 21.7397 17.2425C22.8433 15.7885 23.4397 14.0128 23.4375 12.1875C23.4375 9.94974 22.5486 7.80362 20.9662 6.22129C19.3839 4.63895 17.2378 3.75 15 3.75C12.7622 3.75 10.6161 4.63895 9.0338 6.22129C7.45146 7.80362 6.56251 9.94974 6.56251 12.1875C6.56054 14.014 7.15761 15.7907 8.2622 17.2453H8.26126Z"
                              fill="#232323"
                            />
                          </svg>
                        </div>
                        <div className="contact-deials">
                          <h5>Our Address</h5>
                          <p>916 Water St, Ketchikan, Alaska 99901, USA</p>
                        </div>
                      </div>
                      <div className="contact-ss">
                        <div className="contcat-img">
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.5 23.4375C10.3368 23.4375 8.22212 22.796 6.42346 21.5942C4.62479 20.3924 3.22291 18.6842 2.39507 16.6856C1.56724 14.687 1.35064 12.4879 1.77267 10.3662C2.19469 8.24454 3.23639 6.29566 4.76602 4.76602C6.29566 3.23639 8.24454 2.19469 10.3662 1.77267C12.4879 1.35064 14.687 1.56724 16.6856 2.39507C18.6842 3.22291 20.3924 4.62479 21.5942 6.42346C22.796 8.22212 23.4375 10.3368 23.4375 12.5C23.4375 15.4008 22.2852 18.1828 20.234 20.234C18.1828 22.2852 15.4008 23.4375 12.5 23.4375ZM12.5 3.12501C10.6458 3.12501 8.83325 3.67484 7.29153 4.70498C5.74982 5.73512 4.54821 7.19929 3.83863 8.91235C3.12906 10.6254 2.94341 12.5104 3.30514 14.329C3.66688 16.1475 4.55976 17.818 5.87088 19.1291C7.182 20.4402 8.85246 21.3331 10.671 21.6949C12.4896 22.0566 14.3746 21.8709 16.0877 21.1614C17.8007 20.4518 19.2649 19.2502 20.295 17.7085C21.3252 16.1668 21.875 14.3542 21.875 12.5C21.875 10.0136 20.8873 7.62903 19.1291 5.87088C17.371 4.11273 14.9864 3.12501 12.5 3.12501Z"
                              fill="#232323"
                            />
                            <path
                              d="M16.0859 17.1875L11.7188 12.8203V5.46875H13.2812V12.1719L17.1875 16.0859L16.0859 17.1875Z"
                              fill="#232323"
                            />
                          </svg>
                        </div>
                        <div className="contact-deials">
                          <h5>Time</h5>
                          <p>Monday to Sunday 09:00 AM to 11:00PM</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-8">
                    <div className="contact-form">
                      <form className="row g-3">
                        <div className="col-md-6">
                          <label for="inputFullName" className="form-label">
                            Full Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="FullName"
                            placeholder="Full Name"
                          />
                        </div>
                        <div className="col-md-6">
                          <label for="inputPhone" className="form-label">
                            Phone No.
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="inputPhone"
                            placeholder="Phone No."
                          />
                        </div>
                        <div className="col-md-6">
                          <label for="inputEmailAddress" className="form-label">
                            Email Address
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="inputAddress"
                            placeholder="Email Address"
                          />
                        </div>
                        <div className="col-md-6">
                          <label for="inputSubject" className="form-label">
                            Subject
                          </label>
                          <select id="inputSubject" className="form-select">
                            <option selected>Select...</option>
                            <option>...</option>
                          </select>
                        </div>
                        <div className="col-md-12">
                          <label for="inputMessage" className="form-label">
                            Your Message
                          </label>
                          <textarea
                            name="Your Message"
                            id="YourMessage"
                            cols="30"
                            rows="10"
                            placeholder="Your Message"
                          ></textarea>
                        </div>

                        <div className="col-12">
                          <button type="submit" className="btn btn-primary">
                            Send a Message
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="troo-da-map-section" id="troo-da-map-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.8850349918985!2d72.49642611542339!3d23.027993021903114!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e9b278e046fa5%3A0xd837def63555f791!2sTRooInbound%20Private%20Limited!5e0!3m2!1sen!2sin!4v1677742549252!5m2!1sen!2sin"
                width="600"
                height="450"
                style={{border:"0"}}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
                title="Gmap"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactComponent;
